module.exports = __webpack_public_path__ + "static/media/be.37fc0c68.svg";